// extracted by mini-css-extract-plugin
module.exports = {"Document":"NXBIrHsqxLSY0dCFMHrdfQ==","ArrowIcon":"s1KN+4E1u5LKxsuDaOc5EA==","PdfIcon":"wAfiLsiD--IV927i0H5o-w=="};